import React, { useEffect } from 'react';
import Item from '../../components/Item';
import Input from '../../components/Input';
import { useHistory } from 'react-router-dom';
import translateLabel from '../../helpers/translateLabel';
import Paths from '../../constants/paths';
import { useState } from 'react';
import { observer } from 'mobx-react-lite';
import translations from '../../translations/de';

const NewSector = ({ store }) => {
    const history = useHistory();
    const [error, setError] = useState(null);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        !store.dataLoaded && store.setDataLoaded();
    }, [store]);

    return (
        <Item
            links={[{ path: Paths.SECTORS, name: translations.sectors }]}
            name={`${translations.sector} ${translations.create}`}
            itemModel={{
                title: '',
            }}
            edit={true}
            onSubmit={(event) => {
                setLoading(true);
                error && setError(null);
                store
                    .addSector(event)
                    .then(() => {
                        setLoading(false);
                        history.push(Paths.SECTORS);
                    })
                    .catch((err) => {
                        setError(err);
                        setLoading(false);
                    });
            }}
            onCancel={() => history.goBack()}
            error={error}
            loading={loading}
            determineInputType={({ name, register, error, disabled, index }) => (
                <Input
                    key={index}
                    label={translateLabel(name)}
                    name={name}
                    type="text"
                    {...register(name, {
                        required: true,
                    })}
                    error={error}
                    disabled={disabled}
                />
            )}
        ></Item>
    );
};

export default observer(NewSector);
